let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1lm4z")).then(() => parcelRequire('geWLV'));